import { useHeightSyncState } from '../hooks/useHeightSyncState'

import { OptInInfoCard } from './components/OptInInfoCard'
import classes from './styles.module.scss'

type OptInInfoCardsProps = {
  firstBlockTitle: string
  firstBlockPrefixSubtitle: string
  firstBlockSubtitle: string
  secondBlockTitle: string
  secondBlockSubtitle: string
  thirdBlockTitle: string
  thirdBlockSubtitle: string
}

export const OptInInfoCards = (props: OptInInfoCardsProps) => {
  const { registerHeight, maxHeight } = useHeightSyncState()

  return (
    <div className={classes.root}>
      <OptInInfoCard
        title={props.firstBlockTitle}
        prefixSubtitle={props.firstBlockPrefixSubtitle}
        subtitle={props.firstBlockSubtitle}
        step='1'
        registerHeight={registerHeight}
        maxHeight={maxHeight}
      />
      <OptInInfoCard
        title={props.secondBlockTitle}
        subtitle={props.secondBlockSubtitle}
        step='2'
        registerHeight={registerHeight}
        maxHeight={maxHeight}
      />
      <OptInInfoCard
        title={props.thirdBlockTitle}
        subtitle={props.thirdBlockSubtitle}
        step='3'
        registerHeight={registerHeight}
        maxHeight={maxHeight}
      />
    </div>
  )
}
